import script from "./AccionesFinales.vue?vue&type=script&setup=true&lang=js"
export * from "./AccionesFinales.vue?vue&type=script&setup=true&lang=js"

import "./AccionesFinales.vue?vue&type=style&index=0&id=7b794490&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b794490"]])

export default __exports__